module.exports = __webpack_public_path__ + "img/realestate44.abe2e191.png";